import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiServerService } from '../../core/api';
import { CourierConfig, SettingsService } from '../../core/settings';
import { getPoints, GetPointsRequest } from './pickup-point-api';
import { PickupPointExtended } from './pickup-point.models';
@Injectable({ providedIn: 'root' })
export class PickupPointService {
  apiServerService = inject(ApiServerService);

  maxDistanceToPoint = 3; //En kilómetros

  availableCouriers$: Observable<{ [key: string]: CourierConfig; }> = this.settingsService.getShippingSettings$().pipe(
    map((settings) => {
      const availableCouriers = settings?.availableCouriersForPoints;
      if (!availableCouriers) return {};

      return Object.keys(availableCouriers)
        .filter((key) => availableCouriers[key].enabled)
        .reduce((result, key) => {
          result[key] = availableCouriers[key];
          return result;
        }, {} as { [key: string]: any; });
    })
  );

  constructor(private settingsService: SettingsService,
  ) {
  }

  async getNearestPointsToCoordinates(data: GetPointsRequest): Promise<PickupPointExtended[]> {
    return getPoints(this.apiServerService, data);
  }

}

